import { HourRangeSetting, ViewSetting } from 'owa-calendarview-settings';

/** The layouts available when printing a week view. */
export enum WeekLayout {
    Standard,
    Horizontal,
    Vertical,
}

/** The settings the user can modify when printing a calendar. */
export interface PrintSettings extends HourRangeSetting, ViewSetting {
    /** The id of the calendar that will be printed. */
    calendarId: string;
    /** In week view, the type of layout. */
    weekLayout: WeekLayout;
    /** True to print the agenda page. */
    agenda: boolean;
    /** True to leave room for notes. */
    notes: boolean;
    /** True to display mini month. */
    miniMonth: boolean;
    /** True to hide work week view. */
    hideWorkWeekView?: boolean;
}
